import React, {
	useEffect
} from "react"
import {
	useSelector
} from "react-redux"
import Notifications from "../../../helpers/Notifications"
import sign from "../../../helpers/sign"
import { useMemo } from "react"

const FileListSigner = (props) => {
    const {
        fileSignerWorkingState, // Стейт для запуска и получения признака окончания выполнения
        setFileSignerWorkingState,
        filesState,	// Стейт для загрузки файлов
        fileSignaturesState, // Стейт для выгрузки подписей
        setFileSignaturesState,
		setIsSigning = null// Стейт для прерывания лодинга в случае ошибки подписи
    } = props

	const { systemEnvironment } = useSelector((state) => state.userReducer)

	const reader = useMemo(() => {
		const fileReader = new FileReader()
		fileReader.onerror = error => Notifications.errorNotice(error)
		return fileReader
	}, [])

	reader.onload = (evt) => {
		const base64 = evt.target.result.toString().replace(/^data:(.*,)?/, '')
		signBase64(base64)
	}

	function isBase64(str) {
		const base64Pattern = /^[A-Za-z0-9+\/=]+$/;
		return base64Pattern.test(str);
	}

	function signBase64(base64){
		sign(base64, true, systemEnvironment.cp_address_n).then(result => {
			if (result.res) {
				setFileSignaturesState([...fileSignaturesState, result.res.data.cms])
			}
			else if (result.error){
					setIsSigning(false)
					setFileSignaturesState([])
					setFileSignerWorkingState(null)
			}
		})
	}

    const getUnloadedFilesFromList = (fileList) => fileList?.filter(file => !file.id)

    useEffect(() => {
		if(filesState?.length){
			const filesToUpload = getUnloadedFilesFromList(filesState)
			if (filesToUpload.length && fileSignaturesState.length > 0 && fileSignaturesState.length == filesToUpload?.length) {
				setFileSignerWorkingState(false) // конец выполнения
			} else if (filesToUpload.length && fileSignaturesState.length > 0 && fileSignaturesState.length < filesToUpload?.length) {
				if(filesToUpload[fileSignaturesState.length].originFileObj){
					reader.readAsDataURL(filesToUpload[fileSignaturesState.length].originFileObj)
				} else if(isBase64(filesToUpload[fileSignaturesState.length])){
					signBase64(filesToUpload[fileSignaturesState.length])
				}
			}
		}
	}, [fileSignaturesState])

    useEffect(() =>{
        if(fileSignerWorkingState && filesState?.length){
            try {
                const filesToUpload = getUnloadedFilesFromList(filesState)
                if (filesToUpload.length){
					if(filesToUpload[0].originFileObj){
						reader.readAsDataURL(filesToUpload[0].originFileObj)
					} else if(isBase64(filesToUpload[0])){
						signBase64(filesToUpload[0])
					}
				}else 
                    setFileSignerWorkingState(false)
            } catch (e) {
                Notifications.errorNotice(e.message, null, 5)
            }
        }
    }, [fileSignerWorkingState])

	return null
}
export default FileListSigner
